// extracted by mini-css-extract-plugin
export default {"popover":"q2gRuD91gGSd5lE0XJSiAw==","textOverflowEllipsis":"zcXc1g+Jej-+E3lZbTwxXA=="};